import { useParams } from 'react-router-dom'
import { apiCall } from '@api/resources/apiCall'
import { PROJECT } from '@modules/missions/keaz/const'
import { skipToken } from '@reduxjs/toolkit/query'

export function useTask() {
  const { missionId, taskId } = useParams()

  const {
    data: task,
    isLoading: isTaskLoading,
    isError
  } = apiCall.useAgentumReportControllerFindByIdQuery(
    missionId && taskId ? [missionId, PROJECT, taskId] : skipToken
  )

  let taskError = ''

  if (!task && isError) {
    taskError = `Задача с id ${taskId || 'unknown'} не найдена`
  }

  return { task, isTaskLoading, taskError }
}
